<template>
	<v-layout row justify-center>
		<!-- :class="[itemType === 0 ? cardClass : 'py-1']" -->
		<v-flex
			xs12
			md6
		>
			<v-card class="context-item-card">
				<v-card-title class="justify-center">
					<v-avatar class="context-item-icon" color="secondary">
						<v-icon dark class="elevation-4">{{ icon }}</v-icon>
					</v-avatar>
					<div class="headline mt-3">
						<slot name="title"/>
					</div>
				</v-card-title>
				<v-divider/>
				<v-card-text v-if="!!this.$slots.text">
					<slot name="text"/>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	props: {
		itemType: { default: 0, type: Number },
		cardClass: { default: 'sm6 md4 lg3', type: String },
		icon: { default: 'info', type: String },
	},
};
</script>

<style lang="scss" scoped>
.context-item {
	&-card {
		position: relative;
		margin-top: 2rem;
	}
	&-icon {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
